import { render } from "./IEllipsisText.vue?vue&type=template&id=4d581ac6"
import script from "./IEllipsisText.vue?vue&type=script&lang=js"
export * from "./IEllipsisText.vue?vue&type=script&lang=js"

import "./IEllipsisText.vue?vue&type=style&index=0&id=4d581ac6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__